import { createAction } from 'redux-actions';

export const NAMES = {
  PLAY: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET_PLAY',
  REQUEST_PLAY: 'CLIENT.VIDEO.PLAYBACK_STATUS.REQUEST_PLAY',
  PAUSE: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET_PAUSE',
  REQUEST_PAUSE: 'CLIENT.VIDEO.PLAYBACK_STATUS.REQUEST_PAUSE',
  RESET: 'CLIENT.VIDEO.PLAYBACK_STATUS.RESET',
  END: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET_END',
  SET: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET',
};

export const playVideo = createAction(NAMES.REQUEST_PLAY);
export const pauseVideo = createAction(NAMES.REQUEST_PAUSE);
export const resetPlaybackStatus = createAction(NAMES.RESET);
// Oh boy, don't even try to use it anywhere.
export const setPlaybackStatus = createAction(NAMES.SET);



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/change-playback-status.js